import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Stack, TextField } from '@mui/material';
import { Check } from '@mui/icons-material';
import { PROJECT_LABEL_COLORS } from '../../../../../Constants/ProjectConstants';

const AddLabelModal = ({ open, onClose, onSubmit, label }) => {
  const [name, setName] = useState('');
  const [color, setColor] = useState(PROJECT_LABEL_COLORS[0]);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (!open) return;
    setName(label?.name || '');
    setColor(label?.color || PROJECT_LABEL_COLORS[0]);
  }, [open, label]);

  const trimmedName = name.trim();

  const handleSubmit = async () => {
    if (!trimmedName) return;
    try {
      setSaving(true);
      await onSubmit({ name: trimmedName, color });
    } finally {
      setSaving(false);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="xs">
      <DialogTitle>{label ? 'Edit Label' : 'Add Label'}</DialogTitle>
      <DialogContent>
        <TextField
          autoFocus
          fullWidth
          size="small"
          label="Label name"
          value={name}
          onChange={(event) => setName(event.target.value)}
          onKeyDown={(event) => {
            if (event.key === 'Enter') handleSubmit();
          }}
          inputProps={{ maxLength: 50 }}
          sx={{ mt: 1, mb: 2 }}
        />
        <Stack direction="row" spacing={1} flexWrap="wrap">
          {PROJECT_LABEL_COLORS.map((swatch) => (
            <Box
              key={swatch}
              role="button"
              aria-label={`Use colour ${swatch}`}
              onClick={() => setColor(swatch)}
              sx={{
                width: 28,
                height: 28,
                borderRadius: '50%',
                background: swatch,
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                outline: color === swatch ? '2px solid #000' : 'none',
                outlineOffset: 2,
              }}
            >
              {color === swatch && <Check sx={{ color: '#fff', fontSize: 16 }} />}
            </Box>
          ))}
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button color="inherit" onClick={onClose}>
          Cancel
        </Button>
        <Button variant="contained" onClick={handleSubmit} disabled={!trimmedName || saving}>
          {label ? 'Save' : 'Add'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

AddLabelModal.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  onSubmit: PropTypes.func,
  label: PropTypes.object,
};

export default AddLabelModal;
